module.exports = __webpack_public_path__ + "img/partfour_pic3.e28f8919.png";